var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'PURE')?_c('span',[_vm._v(" "+_vm._s(_vm.locationLabel)+" ")]):(_vm.type === 'LINK')?_c('span',[_c('a',{attrs:{"href":_vm.locationLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.locationLabel))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }